import BlockTemplates from "./blockTemplates";
import { baseURL } from "./_common";

const AppState = {
  baseURL, // https://cortexial-app.firebaseapp.com
  title: "Cortexial",
  firebaseURL: "https://www.gstatic.com/firebasejs/4.6.1/firebase.js",
  firestoreURL:
    "https://www.gstatic.com/firebasejs/4.6.0/firebase-firestore.js",
  previewReady: false,
  loading: false,
  showSettings: true,
  Auth: {
    isLogged: false,
    showRegister: false
  },
  error: {
    show: false,
    text: ""
  },
  blockTemplates: BlockTemplates,
  projects: [],
  projectPages: [],
  currentProjectID: null,
  currentProject: { title: "" },
  currentPageID: null,
  currentPage: {
    title: "",
    projectID: "",
    blockID: 0,
    blocks: [],
    loaded: [],
    loadedDone: []
  }
};

export default AppState;



// WEBPACK FOOTER //
// ./src/util/AppState.js